import React from "react";
import { WorkflowStepManualStatus } from "../../generated/graphql";
import { Actions } from "../Common/ActionCell";
import { ActionsProps } from "../Inputs/DropdownMenu";
import { useUpdateWorkflowStepStatusModal } from "./useUpdateWorkflowStepStatusModal";

interface WorkflowStepActionsProps {
  workflowStepId: string;
  workflowStepManualStatus: WorkflowStepManualStatus;
  submissionTypeName: string;
}

export const WorkflowStepActions = ({
  workflowStepId,
  workflowStepManualStatus,
  submissionTypeName,
}: WorkflowStepActionsProps) => {
  const [showUpdateStatusModal] = useUpdateWorkflowStepStatusModal({
    workflowStepId,
    workflowStepManualStatus,
    submissionTypeName,
    onUpdate: () => {
      // Refresh handled by refetchQueries in mutation
    },
  });

  const actions: ActionsProps[] = [
    {
      label: "Update status",
      onClick: showUpdateStatusModal,
    },
  ];

  return <Actions actions={actions} />;
};
